<script setup>
import { ref, reactive, computed, onMounted } from "vue"
import { Modal } from 'bootstrap';
import axiosIns from "@/plugins/axios.js"
import Banner from '@/views/frontend/pages/trabaja_en_agv/dashboard_postulante/components/banner.vue'
import Footer from '@/views/frontend/pages/trabaja_en_agv/dashboard_postulante/components/footer.vue'
import { useRouter, useRoute } from "vue-router"
import { useToastr } from "@/composables/useToastr"

const toastr = useToastr()
const route = useRoute()
const router = useRouter()
const offer_id = route.query.id
const id_applicant = JSON.parse(localStorage.getItem('userData'))?.id_usuario
const isUserLogged = computed(() => !!localStorage.getItem("userData"))
const questions = ref([])
const jobData = ref([])
let modalInstance = null;

const applyLoading = ref(false)          // <-- loading para Postular
const completeLoading = ref(false)       // <-- loading para Completar Postulación
const alreadyApplied = ref(false)        // <-- true si ya postuló a esta oferta

const similarJobs = ref([
    {
    id: 1,
    work_pos: "Auxiliar de Cosecha",
    place: "Olmos",
    },
    {
    id: 2,
    work_pos: "Operador de Maquinaria",
    place: "Chiclayo",
    },
    {
    id: 3,
    work_pos: "Técnico de Campo",
    place: "Lambayeque",
    },
]);

const getData = () => {
    const config = {
        method: "get",
        url: `/talentoagv/readJobOffer/${offer_id}`,
    };

    axiosIns(config)
    .then(function (response) {
        jobData.value = response.data["result"][0]
    })
    .catch(function (error) {
        console.log(error);
    });
}

// Verifico si el postulante ya tiene una postulación registrada para esta oferta, para
// mostrar el botón como "Postulado" (bloqueado) en vez de "Postular".
const checkAlreadyApplied = () => {
    if (!id_applicant) return

    const config = {
        method: "post",
        url: "/talentoagv/get-applied-offers/",
        headers: { "Content-Type": "application/json" },
        data: { applicant_id: id_applicant },
    }

    axiosIns(config)
    .then(function (response) {
        const rows = response.data?.result || []
        alreadyApplied.value = rows.some(r => String(r.key_oferta_lab_id) === String(offer_id))
    })
    .catch(function (error) {
        console.log(error);
    });
}

const processToFavorites = () => {
  const params = {
    offer_id : offer_id,
    applicant_id : id_applicant,
  }

  const config = {
      method: "post",
      url: "/talentoagv/processFavoriteOffer/",
      headers: {
          'Content-Type': 'application/json'
      },
      data: params
  };

  axiosIns(config)
  .then(function (response) {
    if (response.status === 200) {
      const resultado = response.data["result"];
      allData.value = resultado;      
      toastr.success("Agregado a favoritos.✍🏻", "Operación exitosa.👍🏻");
    }
  })
  .catch(function (error) {
      console.log(error);
  });
  
}

const shareJob = () => {
    if (navigator.share) {
        navigator.share({
            title: jobData.work_pos,
            text: `Revisa esta oferta de trabajo: ${jobData.work_pos}`,
            url: window.location.href,
        });
    } else {
        navigator.clipboard.writeText(window.location.href);
        toastr.success("Enlace copiado al portapapeles.", "Listo");
    }
};

// --- applyToJob con loading (async/await) ---
const applyToJob = async () => {
  // Evitar múltiples clicks y evitar postular dos veces a la misma oferta
  if (applyLoading.value || alreadyApplied.value) return;
  applyLoading.value = true;

  // Obtener id del applicant desde localStorage (null-safe)
  const id_applicant_local = JSON.parse(localStorage.getItem('userData'))?.id_usuario || null;

  try {
    if (!isUserLogged.value) {
      toastr.warning("Crea una cuenta o inicia sesión para postular a esta oferta.✍🏻", "¡Acción necesaria!⚠️");
      applyLoading.value = false;
      return;
    }

    if (!id_applicant_local) {
      toastr.error("No se pudo identificar tu cuenta. Vuelve a iniciar sesión.", "Error");
      applyLoading.value = false;
      return;
    }

    // ----- 1) Verificamos el postulante en backend -----
    const verifyParams = { id: id_applicant_local };
    const verifyConfig = {
      method: "post",
      url: "/talentoagv/verifyApplicant/",
      headers: { "Content-Type": "application/json" },
      data: verifyParams
    };

    const verifyResp = await axiosIns(verifyConfig);
    const data = verifyResp.data || {};

    if (typeof data.completo !== 'undefined') {
      if (!data.completo) {
        const userMsg = data.mensaje || "Tu perfil está incompleto. Completa los datos para postular.";
        toastr.error(userMsg, "Perfil incompleto ❗");
        console.log("verifyApplicant (resumido):", data);
        applyLoading.value = false;
        return;
      }
      // si completo === true -> continuar al getQuestions
      const questionsResp = await axiosIns({
        method: "post",
        url: "/talentoagv/getQuestions/",
        headers: { "Content-Type": "application/json" },
        data: { id_job_offer: offer_id, id_applicant: id_applicant_local }
      });

      if (questionsResp.status === 200) {
        questions.value = questionsResp.data["result"] || [];
        const modalEl = document.getElementById("questionsModal");
        modalInstance = Modal.getOrCreateInstance(modalEl);
        modalInstance.show();
      } else {
        toastr.error("No se pudieron cargar las preguntas de la oferta.", "Error");
      }

      applyLoading.value = false;
      return;
    }

    // 2) Compatibilidad con la respuesta antigua (reporte detallado)
    const reporte = data || {};
    const valido = reporte.valido_general === true;

    if (!valido) {
      let faltantes = [];

      if (reporte.secciones) {
        for (const [seccionKey, seccionObj] of Object.entries(reporte.secciones)) {
          if (seccionObj.cantidad_registros === 0) {
            const niceName = seccionKey.replace('_', ' ');
            faltantes.push(niceName);
          } else if (Array.isArray(seccionObj.registros_con_campos_vacios) && seccionObj.registros_con_campos_vacios.length > 0) {
            faltantes.push(seccionKey);
          } else if (Array.isArray(seccionObj.registros_con_campos_invalidos) && seccionObj.registros_con_campos_invalidos.length > 0) {
            faltantes.push(seccionKey);
          }
        }
      }

      if (reporte.postulante_campos) {
        if (Array.isArray(reporte.postulante_campos.campos_vacios) && reporte.postulante_campos.campos_vacios.length > 0) {
          faltantes.push('datos personales');
        }
        if (Array.isArray(reporte.postulante_campos.campos_invalidos) && reporte.postulante_campos.campos_invalidos.length > 0) {
          faltantes.push('datos personales (inválidos)');
        }
      }

      const uniqueFaltantes = [...new Set(faltantes)];
      const readable = uniqueFaltantes.length > 0 ? uniqueFaltantes.join(" y ") : "datos del perfil";
      const summaryMsg = `Tu perfil está incompleto: falta ${readable}.`;
      toastr.error(summaryMsg, "Perfil incompleto ❗");

      console.log("verifyApplicant (detallado):", reporte);
      applyLoading.value = false;
      return;
    }

    // ----- 3) Si es válido (antigua respuesta) solicitamos preguntas -----
    const questionsResp2 = await axiosIns({
      method: "post",
      url: "/talentoagv/getQuestions/",
      headers: { "Content-Type": "application/json" },
      data: { id_job_offer: offer_id, id_applicant: id_applicant_local }
    });

    if (questionsResp2.status === 200) {
      questions.value = questionsResp2.data["result"] || [];
      const modalEl = document.getElementById("questionsModal");
      modalInstance = Modal.getOrCreateInstance(modalEl);
      modalInstance.show();
    } else {
      toastr.error("No se pudieron cargar las preguntas de la oferta.", "Error");
    }

  } catch (error) {
    const serverMsg = error.response && error.response.data && (error.response.data.detalle || error.response.data.message || error.response.data.mensaje);
    if (serverMsg) {
      toastr.error(serverMsg, "Error");
    } else {
      toastr.error("Ocurrió un error al intentar postular. Intenta nuevamente.", "Error");
    }
    console.log(error);
  } finally {
    applyLoading.value = false;
  }
};


const completeApplication = async () => {
    if (completeLoading.value) return;
    completeLoading.value = true;

    console.log("Envio de respuesta de las preguntas de seleccion")
    let iq = questions.value.findIndex((question, index) => question.answer == null || question.answer == '')
    if(iq != -1){
        toastr.warning("Debes completar todas las preguntas.✍🏻", "¡Acción necesaria!⚠️");
        completeLoading.value = false;
        return false
    }

    const answers = questions.value.map(q => ({
        question_id: q.pregunta_id,
        answer: q.answer
    }));

    const data = JSON.stringify({
        answers : answers,
        id_applicant : id_applicant,
        id_job_offer : offer_id,
    });

    const config = {
        method: 'post',
        url: '/talentoagv/completeApplication/',
        headers: {
            'Content-Type': 'application/json'
        },
        data: data,
    };

    let applied = false
    try {
        const response = await axiosIns(config);
        if (response.data['is_error'] === false) {
            toastr.success('Postulación completada', 'Éxito');
            applied = true
            alreadyApplied.value = true
        } else {
            // manejar caso de error según la respuesta si aplica
            toastr.error(response.data?.message || 'Ocurrió un error.', 'Error');
        }
    } catch (error) {
        console.log(error);
        toastr.error('Ocurrió un error.', 'Error');
    } finally {
        if (modalInstance) {
            modalInstance.hide();
        }
        completeLoading.value = false;
    }

    // Una vez registrada la postulación se actualiza la vista: se lleva al postulante a "Mis postulaciones"
    // para que vea la nueva postulación reflejada.
    if (applied) {
        questions.value = []
        // Navego con recarga completa (en vez de router.push) para que el usuario vea la página
        // de postulaciones ya actualizada con la nueva postulación.
        const modalEl = document.getElementById("questionsModal")
        if (modalEl && modalEl.classList.contains('show')) {
            // Espero a que el modal termine de cerrarse para no dejar el backdrop colgado al cambiar de vista
            modalEl.addEventListener('hidden.bs.modal', () => { window.location.href = '/postulaciones' }, { once: true })
        } else {
            window.location.href = '/postulaciones'
        }
    }
}

const goBack = () => {
    router.go(-1);
};

const shareSimilarJob = (job) => {
    if (navigator.share) {
    navigator.share({
        title: job.work_pos || job.title,
        text: `Revisa esta oferta de trabajo: ${job.work_pos || job.title}`,
        url: `${window.location.origin}/job/${job.id}`,
    });
    } else {
    navigator.clipboard.writeText(`${window.location.origin}/job/${job.id}`);
    toastr.success("Enlace copiado al portapapeles.", "Listo");
    }
};

const goToDetail = (job) => {
    router.push({
        path: "/dashboard_detalle_oferta",
        query: { id: job.id },
    });
};

onMounted(() => {
    getData()
    checkAlreadyApplied()
})
</script>

<template>
    <Banner/>
    <div class="container">
        <div class="row my-5">
            <div class="col-12 col-lg-9 col-md-8 py-3">
                <div class="main-section">
                <div class="job-content">
                    <div class="job-card">
                    <div class="mb-3">
                        <a class="local-back-btn" @click="goBack">
                            <i class="fa-solid fa-arrow-left mt-1"></i>
                            Volver
                        </a>
                    </div>

                    <div class="job-image job-image--mobile">
                        <img 
                        :src="jobData.s3_url != null
                        ? jobData.s3_url 
                        : require('@/assets/talento_agv/img/ofertas_laborales/ofertas_laborales.svg')" 
                        :alt="jobData.work_pos" />
                    </div>

                    <h1 class="job-title">{{ jobData.work_pos }}</h1>

                    <div class="job-information">
                        <span class="vacancies">{{ jobData.n_vacancy }} vacantes</span>
                        <span class="location">
                        <i class="bx bx-map-pin" aria-hidden="true"></i>
                        {{ jobData.place }}
                        </span>
                        <div class="actions">
                        <button
                            v-if="id_applicant"
                            class="icon-btn"
                            type="button"
                            aria-label="Favorito"
                            @click="processToFavorites"
                        >
                            <i class="bx bx-heart"></i>
                        </button>
                        <button
                            class="icon-btn"
                            type="button"
                            aria-label="Compartir"
                            @click="shareJob"
                        >
                            <i class="bx bx-share-alt"></i>
                        </button>
                        <button
                            v-if="!alreadyApplied"
                            class="apply-btn"
                            @click="applyToJob"
                            :disabled="applyLoading"
                            aria-busy="applyLoading"
                            type="button"
                        >
                            <span v-if="!applyLoading">Postular</span>
                            <span v-else>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                &nbsp;Postulando...
                            </span>
                        </button>
                        <button
                            v-else
                            class="applied-btn text-muted"
                            type="button"
                            disabled
                        >
                            Postulado
                        </button>
                        </div>
                    </div>

                    <div class="section-title">Descripción</div>
                    <div class="description-content" v-html="jobData.description"></div>
                    </div>

                    <div class="job-image">
                    <img 
                    :src="jobData.s3_url != null
                    ? jobData.s3_url 
                    : require('@/assets/talento_agv/img/ofertas_laborales/ofertas_laborales.svg')" 
                    :alt="jobData.work_pos" />
                    </div>
                </div>

                <div class="description-section">
                    <div class="row">
                    <div class="col-12 col-md-6 px-4">
                        <div class="section-title">Funciones</div>
                        <div v-html="jobData.functions"></div>
                    </div>
                    <div class="col-12 col-md-6 px-4">
                        <div class="section-title">Requisitos</div>
                        <div v-html="jobData.requirements"></div>
                    </div>
                    </div>
                </div>
                </div>
            </div>

            <!-- Sidebar -->
            <div class="col-12 col-lg-3 col-md-4 py-3">
                <div class="sidebar">
                    <h3 class="sidebar-title">Posiciones Similares</h3>

                    <div v-for="job in similarJobs" :key="job.id" class="similar-job">
                        <div class="similar-job-info">
                        <div class="similar-job-title">{{ job.work_pos }}</div>
                        <div class="similar-job-location">
                            <i class="bx bx-map-pin" aria-hidden="true"></i>{{ job.place }}
                        </div>
                        </div>
                        <div class="similar-job-actions">
                        <button
                            class="icon-btn"
                            type="button"
                            aria-label="Compartir"
                            @click="shareSimilarJob(job)"
                        >
                            <i class="bx bx-share-alt"></i>
                        </button>
                        <button
                            class="icon-btn"
                            type="button"
                            aria-label="Ver detalle"
                            @click="goToDetail(job)"
                        >
                            <i class="bx bx-link-external"></i>
                        </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <Footer/>

    <!----------------------- Modales ----------------------->
    <div ref="questionModal" class="modal fade custom-modal" id="questionsModal" role="dialog">
        <!-- modal-dialog-scrollable: el modal ocupa como máximo el alto de pantalla y solo el
             cuerpo (la lista de preguntas) scrollea; el encabezado y el botón quedan siempre visibles -->
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable questions-modal-dialog">
            <div class="modal-content">
                <!-- Modal Header -->
                <div class="modal-header">
                <h4 class="modal-title text-center">Preguntas de selección</h4>
                <button type="button" class="close" data-bs-dismiss="modal">
                    <span>&times;</span>
                </button>
                </div>

                <!-- Modal body -->
                <div class="modal-body">
                    <form>
                        <div v-for="(question, index) in questions" :key="index" class="form-group">
                            <label>{{ index + 1 }}.- {{ question.pregunta_text }}</label>
                            <input v-if="question.pregunta_type === 'A'" type="text" class="form-control" v-model="question.answer" placeholder="" />
                            <!-- Agrega aquí otras condiciones para diferentes tipos de preguntas, si es necesario -->
                            <div v-if="question.pregunta_type === 'C'">
                                <div v-for="option in question.options" :key="option.opcion_id" class="form-check">
                                    <input class="form-check-input" type="radio" :name="'question' + index" :value="option.opcion_text" v-model="question.answer">
                                    <label class="form-check-label">{{ option.opcion_text }}</label>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>

                <!-- Fuera del área con scroll para que el botón esté siempre visible -->
                <div class="modal-footer">
                    <button
                    type="button"
                    class="btn btn-agv-seis price-btn btn-block"
                    @click="completeApplication"
                    :disabled="completeLoading"
                    >
                    <span v-if="!completeLoading">Completar Postulación</span>
                    <span v-else>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        &nbsp;Enviando...
                    </span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
.questions-modal-dialog {
    max-height: calc(100vh - 3.5rem);
}
.questions-modal-dialog .modal-content {
    max-height: calc(100vh - 3.5rem);
}

.main-section {
    background: white;
    border-radius: 12px;
    border: 2px solid var(--bg-primary-as-light);
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.job-content {
    display: flex;
    padding: 25px;
}

.job-card {
    flex: 1;
    margin-right: 20px;
}

.local-back-btn {
    color: var(--bg-primary-as-light);
    text-decoration: none;
    font-weight: 500;
    display: flex;
    align-items: start;
    gap: 5px;
    cursor: pointer;
}

/* .local-back-btn:hover {
    text-decoration: underline;
} */

.job-title {
    font-size: 28px;
    font-weight: bold;
    color: #333;
    margin-bottom: 10px;
    line-height: 1.2;
}

.job-information {
    display: flex;
    align-items: center;
    gap: 15px;
    margin-bottom: 25px;
    flex-wrap: wrap;
}

.vacancies {
    color: #666;
    font-size: 14px;
}

.location {
    display: flex;
    align-items: center;
    gap: 5px;
    color: #666;
    font-size: 14px;
}

.actions {
    display: flex;
    align-items: center;
    gap: 10px;
}

.icon-btn {
    border: 1px solid rgba(10, 30, 70, 0.12);
    background: #fff;
    width: 34px;
    height: 34px;
    border-radius: 999px;
    display: grid;
    place-items: center;
    cursor: pointer;
    transition: background 0.15s, border-color 0.15s;
}

.icon-btn i {
    font-size: 18px;
    color: var(--bg-primary-as-light);
}

.icon-btn:hover {
    background: rgba(25, 87, 209, 0.06);
    border-color: rgba(25, 87, 209, 0.35);
}

.apply-btn {
    margin-left: auto;
    padding: 6px 14px;
    border-radius: 999px;
    border: 1px solid var(--bg-primary-as-light);
    background: #fff;
    color: var(--bg-primary-as-light);
    font-weight: 600;
    font-size: 13px;
    cursor: pointer;
    transition: background 0.15s, color 0.15s;
}

.apply-btn:hover {
    background: var(--bg-primary-as-light);
    color: #fff;
}

.applied-btn {
    margin-left: auto;
    padding: 6px 14px;
    border-radius: 999px;
    border: 1px solid #6B7385;
    background: #fff;
    font-weight: 600;
    font-size: 13px;
    cursor: not-allowed;
}

.section-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin-bottom: 15px;
    margin-top: 25px;
}

.section-title:first-of-type {
    margin-top: 0;
}

.function-list,
.requirements-list {
    list-style: none;
    padding: 0;
}

.function-list li,
.requirements-list li {
    margin-bottom: 8px;
    padding-left: 15px;
    position: relative;
    color: #555;
    line-height: 1.4;
}

.function-list li:before,
.requirements-list li:before {
    content: "•";
    position: absolute;
    left: 0;
    color: #4a90e2;
    font-weight: bold;
}

.job-image {
    width: 250px;
    text-align: center;
}
.job-image img {
    width: 100%;
    height: 240px;
    object-fit: cover;
    border-radius: 8px;
}

.job-image--mobile {
    display: none;
}

.description-section {
    padding: 20px 25px;
    border-top: 1px solid #eee;
}

.description-title {
    font-size: 16px;
    font-weight: 600;
    color: #333;
    margin-bottom: 10px;
}

.description-content {
    color: #666;
    line-height: 1.5;
}

/* Sidebar */
.sidebar {
    background: white;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    height: fit-content;
}

.sidebar-title {
    font-size: 16px;
    font-weight: 600;
    color: #333;
    margin-bottom: 15px;
}

.similar-job {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    margin-bottom: 10px;
    transition: border-color 0.2s;
    flex-wrap: wrap;
}

.similar-job:hover {
    border-color: var(--bg-primary-as-light);
}

.similar-job-info {
    flex: 1;
}

.similar-job-title {
    font-weight: 500;
    color: #333;
    margin-bottom: 4px;
    font-size: 14px;
}

.similar-job-location {
    color: #666;
    font-size: 12px;
    display: flex;
    align-items: center;
    gap: 4px;
}

.similar-job-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    padding-block: 10px;
}

/* Responsive */
@media (max-width: 768px) {
    .job-content {
        flex-direction: column;
    }

    .job-image {
        display: none;
    }
    .job-image--mobile {
        display: flex;
        justify-content: center;
        margin: 8px 0 16px;
        width: 100%;
    }
    .job-image--mobile img {
        width: min(240px, 70%);
        height: auto;
        aspect-ratio: 3 / 4;
        object-fit: cover;
        border-radius: 8px;
    }
}
</style>